import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import {
  PARTNER_COMPANIES_TYPE_NAME,
  PartnerCompaniesTypeEnum,
} from '@constants';

import type { PartnerCompanyTypeChipProps } from './types';
import { StyledChip } from './styles';

export function PartnerCompanyTypeChip({
  isMainPartnerCompany,
  text,
  title,
  fontSize,
  size = 'medium',
}: Readonly<PartnerCompanyTypeChipProps>) {
  const label = isMainPartnerCompany
    ? PARTNER_COMPANIES_TYPE_NAME[PartnerCompaniesTypeEnum.MOTHER]
    : PARTNER_COMPANIES_TYPE_NAME[PartnerCompaniesTypeEnum.CHILD];

  const bgColor = isMainPartnerCompany
    ? NEW_COLORS.SEMANTICS.WARNING[500]
    : NEW_COLORS.SEMANTICS.INFO[300];

  return (
    <StyledChip
      $textColor={NEW_COLORS.PRIMARY[950]}
      $bgColor={bgColor}
      $fontSize={fontSize}
      label={text ?? label}
      title={title}
      size={size}
    />
  );
}
